(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Events.AncillaryEvent",
                    {
                        url: "/AncillaryGroup/:EventGroupId/Event/:EventId",
                        component: "ancillaryEvent",
                        PageTitle: "Event Details | Marketing Tracker"
                    });
        }
    ]);

    app
        .component("ancillaryEvent",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/Events/AncillaryEvent/ancillary-event-template.html",
                controller: ancillaryEventController,
                bindings: {
                }
            });

    ancillaryEventController.$inject = ["$state", "marketingTrackerEventApi", "marketingTrackerAncillaryEventGroupApi", "$stateParams", "$mdDialog", "$timeout", "figToaster", "marketingTrackerSalesTrackerInputApi"];
    function ancillaryEventController($state, marketingTrackerEventApi, marketingTrackerAncillaryEventGroupApi, $stateParams, $mdDialog, $timeout, figToaster, marketingTrackerSalesTrackerInputApi) {
        var $ctrl = this;
        ng.extend($ctrl,
            {
                ui: {
                    saving: false,
                    deleting: false
                },
                checkChanged: checkChanged,
                deleteEvent: deleteEvent,
                hasSaved: false,
                saveViaKeyboard: saveViaKeyboard,
                showSavedMessage: showSavedMessage,
                update: update,
                openAddSpendingFromEventModal: openAddSpendingFromEventModal
            });

        function checkChanged() {
            if (!ng.equals($ctrl.eventGroup, $ctrl.eventGroupCopy) || !ng.equals($ctrl.event, $ctrl.eventCopy))
                return false;
            else return true;
        }

        function deleteEvent($event) {
            var message = "", toastClass = "";
            var confirm = $mdDialog.confirm({
                title: "Are you sure you want to delete this event?",
                targetEvent: $event,
                ariaLabel: "Confirm event removal",
                ok: "Yes",
                cancel: "No",
                multiple: true,
                clickOutsideToClose: false
            });
            $mdDialog.show(confirm).then(function () {
                $ctrl.ui.deleting = true;
                return marketingTrackerAncillaryEventGroupApi.deleteAncillaryEvent($ctrl.eventGroup.Id, $ctrl.event.Id)
                    .then(function () {
                        message = "Event deleted.";
                        toastClass = "is-success";
                        $state.go("Home.Tools.MarketingTrackerNew.Events.Calendar.CalendarView");
                        return $mdDialog.hide({
                            eventGroupId: $ctrl.eventGroup.Id,
                            eventId: $ctrl.event.Id,
                            toDelete: true
                        });
                    })
                    .catch(function (error) {
                        console.log("Error: " + error.data);
                        message = "There was a problem updating your data. Please try again shortly.";
                        toastClass = "is-error";
                    })
                    .finally(function () {
                        $ctrl.ui.isUploading = false;
                        $ctrl.ui.deleting = false;
                        return figToaster.showSimple(message, "top", toastClass);
                    });
            });
        }

        function showSavedMessage() {
            $ctrl.hasSaved = true;
            $timeout(function () {
                $ctrl.hasSaved = false;
            }, 3000);
        }

        function update() {
            var message = "", toastClass = "";
            $ctrl.ui.saving = true;
            marketingTrackerAncillaryEventGroupApi.update($ctrl.eventGroup.Id, $ctrl.eventGroup)
                .then(function () {
                    marketingTrackerAncillaryEventGroupApi.updateAncillaryEvent($ctrl.eventGroup.Id, $ctrl.event.Id, $ctrl.event)
                        .then(function () {
                            $ctrl.eventCopy = ng.copy($ctrl.event);
                            $ctrl.eventGroupCopy = ng.copy($ctrl.eventGroup);
                            showSavedMessage();
                        })
                        .catch(function (error) {
                            console.log("Update error:" + error.data);
                        });
                    message = "Changes saved.";
                    toastClass = "is-success";
                })
                .catch(function (error) {
                    console.log("Error: " + error.data);
                    message = "There was a problem updating your data. Please try again shortly.";
                    toastClass = "is-error";
                })
                .finally(function () {
                    $ctrl.ui.saving = false;
                    return figToaster.showSimple(message, "top", toastClass);
                });
        }

        function saveViaKeyboard(event) {
            if (event.ctrlKey && event.keyCode === 83) {
                event.preventDefault();
                update();
            }
        }

        function openAddSpendingFromEventModal () {
            $mdDialog.show(
                {
                    controller: "addSpendingController",
                    controllerAs: "$ctrl",
                    templateUrl: "App/Tools/MarketingTrackerNew/Components/AddSpending/add-spending.component.html",
                    bindToController: true,
                    eventName: $ctrl.event.Description,
                    eventCost: $ctrl.eventGroup.Cost,
                    eventDate: $ctrl.event.EventDate,
                    eventGroupId: null,
                    ancillaryEventGroupId: $ctrl.eventGroup.Id,
                })
                .then(function (spending) {
                    $ctrl.spending = spending;
                })
        }

        $ctrl.$onInit = function () {
            marketingTrackerEventApi.getAncillaryEvent($stateParams.EventGroupId, $stateParams.EventId).then(function (response) {
                $ctrl.event = response;
                $ctrl.event.EventDate = new Date($ctrl.event.EventDate);
                $ctrl.eventCopy = ng.copy($ctrl.event);
            });
            marketingTrackerEventApi.getAncillaryEventGroup($stateParams.EventGroupId).then(function (response) {
                $ctrl.eventGroup = response;
                $ctrl.eventGroupCopy = ng.copy($ctrl.eventGroup);
            });
            marketingTrackerSalesTrackerInputApi.getSpendingByAncillaryEventGroupId($stateParams.EventGroupId).then(function (response) {
                $ctrl.spending = response;
            });
        };
    }

})(window.app, window.angular); //jshint ignore:line